define(['moduler'], function (Moduler) {
    'use strict';
    /*
     * filter functionality with checkboxes that is used to load content from server
     * has support for a load more button
     * 
     * the filter can be additive (multiple), single select or multilevel
     * additive mean the content need to contain all filters to be included
     * single select will unselect other filters when a filter is clicked, behaving like a radiobutton list,
     * multilevel have two levels of filters
     * 
     * data for the ajax request is compiled from the form contents of the form element the module is loaded for 
     */
    return Moduler.create({
        defaults: {
            event: 'change',
            url: null,
            contentElement: null,
            triggerElement: 'input[type="checkbox"], .js-triggerForm',
            loadOnInit: false,
            insertMode: 'append', // modes: [null|replace|append]. 
            loadingCssClass: 'is-loading',
            filterType: 'multiple', // 'single' for single filters, meaning selecting one unselects the others, multiple can select multiple, and multilevel is special sauce
            loadMoreElement: null,
            loadMoreEvent: 'click',
            page: 1,
            clearFiltersElement: null,
            clearFiltersEvent: 'click',
            uniqueId: null,
            queryPrefix: 'cat',
            hashPrefix: 'block-',
            customTriggerElement: null, // add a data-category to these elements with the category that should be toggled on click, remember to make them unique to the block
            customTriggerEvent: 'click',
            searchFieldElement: null
        },

        init: function () {
            var self = this;

            self.options.page = 1;

            self.contentElement = document.querySelector(self.options.contentElement) ?? self.el;

            if (self.options.triggerElement) {
                self.el.querySelectorAll(self.options.triggerElement).forEach(trigger => {
                    trigger.addEventListener(self.options.event, Moduler.utils.bind(self.filter, self));
                });
            } else {
                self.el.addEventListener(self.options.event, Moduler.utils.bind(self.filter, self));
            }

            if (self.options.customTriggerElement) {
                document.addEventListener(self.options.customTriggerEvent, function (e) {
                    var trigger = e.target.closest(self.options.customTriggerElement);
                    if (trigger) {
                        var cat = trigger.getAttribute('data-category');

                        self.enableFilter(cat);
                        self.setHistoryState();
                        self.sendRequest.call(self, 'replace');

                        e.preventDefault();
                        document.getElementById(self.options.hashPrefix + self.options.uniqueId).scrollIntoView();
                    }
                });
            }

            self.clearElements = [];
            if (self.options.clearFiltersElement) {
                self.clearElements = self.el.querySelectorAll(self.options.clearFiltersElement);
                self.clearElements.forEach(clearTrigger => {
                    clearTrigger.addEventListener(self.options.clearFiltersEvent, Moduler.utils.bind(self.clearAll, self));
                });
            }

            self.searchField = self.el.querySelector(self.options.searchFieldElement);

            if (self.searchField) {
                self.searchField.addEventListener('keyup', function (e) {
                    self.filter.call(self, e);
                });
                self.searchField.addEventListener('blur', function (e) {
                    e.preventDefault();
                    self.filter.call(self, e);
                });
                self.searchField.addEventListener('keypress', function (e) {
                    if (e.key == 'Enter') {
                        e.preventDefault();
                        self.filter.call(self, e);
                    }
                });
            }

            if (self.options.loadMoreElement) {
                self.loadMoreElement = document.querySelector(self.options.loadMoreElement);
                if (self.loadMoreElement) {
                    self.loadMoreElement.addEventListener(self.options.loadMoreEvent, Moduler.utils.bind(self.loadMore, self));
                }
            }

            // init categories from url
            self.categories = [];
            var categoryQueryKey = self.getQueryKey(self);
            var filtered = false;
            new URL(window.location).searchParams.forEach((v, p) => {
                if (p == categoryQueryKey && self.categories.indexOf(v) == -1) {
                    self.categories.push(v);
                    self.enableFilter(v);
                    filtered = true;
                }
            });

            if (filtered) {
                self.sendRequest.call(self, 'replace');
            }
        },

        clearAll: function (e) {
            var self = this;
            e.preventDefault();
            self.filter.call(self, e, true);
        },

        filter: function (e, clear) {
            var self = this;
            self.options.page = 1;

            var element = e.target;

            if (clear) {
                self._getMainFilters().forEach((filter, i) => {
                    self.disableFilter(filter);
                });
                if (self.searchField) {
                    self.searchField.value = '';
                }
            } else {
                if (element.type === 'checkbox' || element.type === 'radio') {
                    if (element.checked) {
                        self.enableFilter(element.value);
                    } else {
                        self.disableFilter(self._getFilter(element.value));
                    }
                }
                if (self.searchField && element === self.searchField) {
                    // set some query param
                }
            }

            self.setHistoryState();

            self.sendRequest.call(self, 'replace');
        },

        setHistoryState: function () {
            var self = this;
            var key = self.getQueryKey(self);

            var queryParams = new URL(window.location).searchParams;
            queryParams.delete(key);
            self.categories.forEach(c => {
                queryParams.append(key, c);
            });

            var query = '?' + queryParams.toString();

            if (self.options.uniqueId) {
                query += '#' + self.options.hashPrefix + self.options.uniqueId;
            }
            if (query.startsWith('#')) {
                window.history.pushState(null, null, location.pathname + query);
            } else if (query.length == 0) {
                window.history.pushState(null, null, location.pathname);
            } else {
                window.history.pushState(null, null, query);
            }
        },

        _getFilter: function (category) {
            var self = this;
            var check = self.el.querySelector('.js-fpc > input[type="checkbox"][value="' + category + '"], .js-fsc > input[type="checkbox"][value="' + category + '"]');
            return check.closest('.js-fpc, .js-fsc');
        },

        _getMainFilters: function () {
            var self = this;
            return self.el.querySelectorAll('.js-fpc');
        },

        _toggleState: function (filter, state) {
            var self = this;
            if (!filter) {
                return;
            }
            state ? filter.classList.add('is-active') : filter.classList.remove('is-active');

            var check = filter.querySelector('input[type="checkbox"]');
            if (check) {
                if (check.checked != state) {
                    check.checked = state;
                }
                if (check.value.length > 0) {
                    var index = self.categories.indexOf(check.value);
                    if (state && index == -1) {
                        self.categories.push(check.value);
                    } else if (!state && index > -1) {
                        self.categories.splice(index, 1);
                    }
                }
            }
        },

        _setClearElementsState: function () {
            var self = this;
            self.clearElements.forEach(ce => {
                self._toggleState(ce, self.categories.length == 0);
            });
        },

        disableFilter: function (filter) {
            var self = this;
            self._toggleState(filter, false);

            if (self.options.filterType === 'multilevel') {// disable children
                var subFilterGroup = self.el.querySelector('.js-subFilters[data-parentid="' + filter.querySelector('input[type="checkbox"]').value + '"]');
                if (subFilterGroup) {
                    subFilterGroup.classList.remove('is-active');
                    subFilterGroup.querySelectorAll('.js-fsc').forEach(subFilter => {
                        self._toggleState(subFilter, false);
                    });
                }
            }

            self._setClearElementsState();
        },

        enableFilter: function (category) {
            var self = this;
            var filter = self._getFilter(category);
            var mainFilter = filter.classList.contains('js-fpc') ? filter : null;
            if (self.options.filterType === 'single' || self.options.filterType === 'multilevel' && mainFilter) {
                self._getMainFilters().forEach(function (sibling, i) {
                    if (sibling != mainFilter) {
                        self.disableFilter(sibling);
                    }
                });
                if (self.options.filterType === 'multilevel') {
                    var subFilterGroup = self.el.querySelector('.js-subFilters[data-parentid="' + category + '"]');
                    if (subFilterGroup) {
                        subFilterGroup.classList.add('is-active');
                    }
                }
            }
            self._toggleState(filter, true);

            self._setClearElementsState();
        },

        sendRequest: function (insertMode) {
            var self = this;

            self.isLoading = true;

            self.el.classList.add(self.options.loadingCssClass);
            if (self.loadMoreElement) {
                self.loadMoreElement.classList.add(self.options.loadingCssClass);
            }

            // this will only work with post requests
            var formData = new FormData(self.el.nodeName == 'FORM' ? self.el : self.el.querySelector('form'));
            formData.append('page', self.options.page);

            return fetch(self.options.url, {
                method: 'POST',
                body: formData
            }).then(response => {
                self.isLoading = false;
                self.el.classList.remove(self.options.loadingCssClass);
                if (self.loadMoreElement) {
                    self.loadMoreElement.classList.remove(self.options.loadingCssClass);
                }
                self.el.dispatchEvent(new CustomEvent('ajax-always'));
                if (response.status != 200) {
                    self.el.dispatchEvent(new CustomEvent('ajax-error'));
                } else {
                    response.text().then(function (text) {
                        if (response.headers.get('content-type').indexOf('text/html') !== -1) {
                            if (insertMode === 'replace') {
                                self.contentElement.innerHTML = text;
                            } else if (insertMode === 'append') {
                                self.contentElement.innerHTML += text;
                            }
                            Moduler.loadModules(self.contentElement);
                        }
                        if (self.loadMoreElement) {
                            self.loadMoreElement.style.display = response.headers.get('X-LastPage') ? 'none' : '';
                        }
                        self.el.dispatchEvent(new CustomEvent('ajax-done', { response: text }));
                    });
                }
            });
        },

        loadMore: function (e) {
            var self = this;
            if (e) {
                e.preventDefault();
            }

            // prevent additional requests when user spam-clicks
            if (self.isLoading) {
                return;
            }

            // increase page by one
            self.options.page += 1;
            self.sendRequest.call(self, 'append');
        },

        getQueryKey: function (self) {
            var key = self.options.queryPrefix;
            if (self.options.uniqueId) {
                key += self.options.uniqueId;
            }
            return key;
        }
    });
});